<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError && iban_id" :to="{ name: `${ibansRoutePrefix}.edit`,params:{iban_id} }"  class="btn btn-primary btn-sm" v-can:edit="`${permissionPrefix}_bank`">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <input-text v-model="iban_name" :options="{ id: 'iban_name', transPrefix: `${transPrefix}.fields`, label: 'iban_name', disabled: true }"/>
              <input-text v-model="iban_number" :options="{ id: 'iban_number', transPrefix: `${transPrefix}.fields`, label: 'iban_number', disabled: true }"/>
              <select-banks v-model="iban_bank_id" :options="{ id: 'iban_bank_id', transPrefix: `${transPrefix}.fields`, label: 'iban_bank', disabled: true }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { IBANS_SHOW as CRUD_ACTION_SHOW } from 'actions/ibans';
  const CRUD_CODE="captains";
  const IBANS_CODE="ibans";
  export default {
    name: "IbanShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_CODE,
        ibansRoutePrefix: `${CRUD_CODE}.${IBANS_CODE}`,
        ibansTransPrefix: `${CRUD_CODE}.${IBANS_CODE}`,
        id:this.$router.currentRoute.params.id,
        iban_id: '',
        country_id: '',
        iban_bank_id:'',
        iban_name:'',
        iban_number:'',
        connected: false,
        ready_to_work: false,
        suspended: false,
        email: '',
        mobile_number: '',
        name:'',
        serverError: '',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.iban_id=response.data.id;
          this.iban_number=response.data.iban;
          this.iban_name=response.data.name;
          this.iban_bank_id=response.data.bank?response.data.bank.id:null;
          this.country_id=this.iban_bank_id?response.data.bank.country.id:null;
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
